<template>
  <BaseTable
    :headers="[
      t('global.date'),
      t('global.items.product', 1),
      t('global.state')
    ]"
    :rows="
      filteredImports?.map((item) => ({
        id: item.id,
        routerLink: {
          name: 'product-import',
          params: {
            id: item.id
          }
        },
        cells: [
          filters.dateTime(item.createdAt),
          item.productsCount,
          item.state
        ],
        actions: setOptions(item),
        disabled: isDeleted(item),
        clickable: !isDeleted(item)
      }))
    "
    @action="onAction"
    v-test="'imports'"
  ></BaseTable>
</template>

<script
  setup
  lang="ts"
>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { openConfirmationModal } from './utils';

const { t } = useI18n();
const imports = inject<Ref<any[]>>('page-items');
const filteredImports = computed(() =>
  imports?.value?.filter((item) => item.productsCount > 0),
);

const isDeleted = (item: any) => {
  return item.state === 'deleted';
};

const setOptions = (item: any) => {
  const options = [];
  if (isDeleted(item)) {
    options.push('restore');
  } else {
    options.push('delete');
  }
  return options;
};

const onAction = ({ id, option }) => {
  const item = filteredImports.value?.find((item) => item.id === id);
  if (option === 'delete' || option === 'restore') {
    openConfirmationModal(id, item.state === 'deleted');
  }
};
</script>
